import {Svg, Path} from 'react-native-svg';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useLingui} from '@lingui/react/macro';
import {useMenu} from 'extensions/viewport/useMenu';
import {useModalCreateFolder} from 'interface/hooks/useModalCreateFolder';
import {vectors, colors} from 'config/styles';

import * as transfers from 'interface/hooks/effects/transfers';

export function useMenuFolder(
  id: string,
  name: string,
) {
  const {t} = useLingui();
  const put = useDispatch();
  const icon = useCallback((viewbox: string, width: number, height: number, icon: string) =>
    <Svg viewBox={viewbox} width={width} height={height}>
      <Path d={icon} fill={colors.neutral.mid}/>
    </Svg>
  , []);

  const modalCreateFolder = useModalCreateFolder(id);
  const uploadHere = useCallback(transfers.uploadStart(put, id), [id]);

  const {open, exit, reference} = useMenu(() => [
    {
      command: 'header',
      text: name === 'myfiles' ? t`My Files` : name,
    },
    {
      command: 'create-folder',
      text: t`Create Folder`,
      icon: icon('0 0 20 16', 16, 16, vectors.icons.folder),
    },
    {
      command: 'upload-here',
      text: t`Upload Here`,
      icon: icon('0 0 14 17', 16, 16, vectors.icons.upload),
    },
  ], (command) => {
    exit();
    switch (command) {
      case 'create-folder':
        return modalCreateFolder.open();
      case 'upload-here':
        return uploadHere();
    }
  });

  return {open, exit, reference};
}
